// extracted by mini-css-extract-plugin
module.exports = {"recordItem":"styles_recordItem__FurVd","empty":"styles_empty__A0PU5","high":"styles_high__vKyzA","bolder":"styles_bolder__aqEon"};